import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth";
import { useCookies } from "react-cookie";
import jwt_decode from "jwt-decode";

export const ProtectRoutes = ({ allowedRole }) => {
  const { cookies } = useAuth();
  const location = useLocation();
  // var decoded = jwt_decode(cookies.token);
  console.log(cookies);
  // const [cookies, setCookies] = useCookies();

  // return cookies.data ? <Outlet/> : <Navigate to='/login' exact />
  return cookies.data ? (
    cookies.data.token ? (
      cookies.data.role === allowedRole ? (
        <Outlet />
      ) : (
        <Navigate to="/unauthorized" state={{ from: location }} replace />
      )
    ) : (
      <Navigate to="/login" state={{ from: location }} replace />
    )
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};
